import React, { FC } from 'react';
import * as StyledStepType from '../../components/registerShipment/registerShipmentForm/stepType/stepType.styles';
// import { useTranslation } from 'react-i18next';
import { getCurrentLangPretty } from '../../helpers/url/urlHelpers';
import useCountries from '../../hooks/useCountries';
// import { ReactComponent as IconMailOpen } from '../../../../../icons/mail-open.svg';
import { ReactComponent as IconMailOpen } from '../../icons/mail-open.svg';
import { ReactComponent as IconParcel } from '../../icons/parcel.svg';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import FormikRadioTile from '../base/forms/formikRadioTile/formikRadioTile';
import FormikSelect from '../base/forms/formikSelect';
import { Column, Columns } from '../base/grid';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: boolean;
	errors: any;
	touched: any;
}

const DeliverytimeFormFields: FC<Props> = ({ setFieldTouched, setFieldValue, values }) => {
	// const { t } = useTranslation('generalForm');
	const lang = getCurrentLangPretty();
	const { countries } = useCountries(lang, true);
	return (
		<div>
			<FormikFieldWrapper name="deliveryType" languageComponent="generalForm" label="Hvað ertu að senda?">
				<Columns>
					<Column tablet={1 / 4}>
						<FormikRadioTile
							setFieldValue={setFieldValue}
							id="letter"
							name="service"
							icon={IconMailOpen}
							active={false}
							label="Bréf"
						/>
					</Column>
					<Column tablet={1 / 4}>
						<FormikRadioTile
							setFieldValue={setFieldValue}
							id="parcel"
							name="service"
							icon={IconParcel}
							active={false}
							label="Pakki"
						/>
					</Column>
				</Columns>
			</FormikFieldWrapper>

			<FormikFieldWrapper label="Veldu land" name="country" languageComponent="generalForm">
				<Columns>
					<Column tablet={2 / 4}>
						<FormikSelect
							id="country"
							name="country"
							value={values.country}
							options={countries}
							onBlur={setFieldTouched}
							styles={StyledStepType.countriesSelectStyles}
							onChange={setFieldValue}
						/>
					</Column>
				</Columns>
			</FormikFieldWrapper>
		</div>
	);
};

export default DeliverytimeFormFields;
